export interface GenieCategory {
  id: string;
  label: string;
  color: string;
}

export const GenieCategories: GenieCategory[] = [
  { id: "automotive", label: "Automotive", color: "#4E9CFF" },
  { id: "appliances", label: "Appliances", color: "#6A8DFF" },
  { id: "electronics", label: "Electronics", color: "#7B6CFF" },
  { id: "healthcare", label: "Healthcare", color: "#5FBAFF" },
  { id: "retail", label: "Retail", color: "#937CFF" },
  { id: "finance", label: "Finance", color: "#A28CFF" },
  { id: "education", label: "Education", color: "#B37DFF" },
  { id: "hospitality", label: "Hospitality", color: "#A06CFF" },
  { id: "support", label: "Customer Support", color: "#6680FF" },
  { id: "other", label: "Other", color: "#6B7280" },
];
